// extracted by mini-css-extract-plugin
export default {"sheet":"styles_sheet__FA10o","buttons":"styles_buttons__+ZCL6","brand-color-2":"styles_brand-color-2__eBPir","primary-text":"styles_primary-text__q9Icj"};